exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* label {\n    width: 55px;\n} */\n\n/* input {\n    width: 200px;\n} */\n\n.form-group {\n    padding: 0 5px;\n}\n\nlabel.section {\n    width: 100%;\n    text-align: center;\n    border-bottom: 1px solid #f1f1f1;\n    color: #a1a1a1;\n    font-weight: 100;\n}\n\n.tags {\n    display: block;\n    width: 100%;\n    height: 34px;\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    color: #555;\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075)\n}\n\n\n/* .row {\n    min-width: 33%;\n    float: left;\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n@media only screen and (max-width: 600px) {\n    .row {\n        width: 100%;\n        padding-left: 0px;\n        padding-right: 0px\n    }\n} */\n\n.tags {\n    box-shadow: 0px;\n    height: 34px !important;\n}\n\n.filterTag {\n    width: 33%\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/employees-filter/employees-filter.component.css
// module id = ../../../../../src/app/shared/components/employees-filter/employees-filter.component.css
// module chunks = main